
APP.datepicker = function () {

  $.datepicker.regional["vi-VN"] =
	{
		closeText: "Đóng",
		prevText: "Trước",
		nextText: "Sau",
		currentText: "Hôm nay",
		monthNamesShort: ["Tháng một", "Tháng hai", "Tháng ba", "Tháng tư", "Tháng năm", "Tháng sáu", "Tháng bảy", "Tháng tám", "Tháng chín", "Tháng mười", "Tháng mười một", "Tháng mười hai"],
		monthNamesShort: ["Tháng 1", "Tháng 2", "Tháng  3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"],
		dayNames: ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"],
		dayNamesShort: ["CN", "Hai", "Ba", "Tư", "Năm", "Sáu", "Bảy"],
		dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
		weekHeader: "Tuần",
		dateFormat: "dd/mm/yy",
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ""
	};

	$.datepicker.setDefaults($.datepicker.regional["vi-VN"]);

  $('#account-form .datepicker').datepicker({
    changeMonth: true,
    changeYear: true,
    yearRange: '-100:+0',
    onSelect : function (date,e) {
      APP.validAccountForm()
    },
    onUpdateDatepicker : updateDatepicker,
  });

  $('#account-form .datepicker').on('input', function(){
    $(this).datepicker( "hide" );
  });


  $('.form-submit').on('focus', function(){
    $('.hasDatepicker').datepicker( "hide" );
    if ($('.ui-datepicker-year').length) {
      $('.ui-datepicker-year').select2('close');
      $('.ui-datepicker-month').select2('close');
    }

  });

  function updateDatepicker() {
    $('.ui-datepicker-month').select2();
    $('.ui-datepicker-year').select2();
  }

}
